<label class="switch">
    <input type="checkbox" [value]="value" [checked]="value" [(ngModel)]="value" [disabled]="disabled">
    <span class="slider round" [ngClass]="{'disabled': disabled}"></span>
</label>